import { Directive, ElementRef, Input, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { PoliciesService } from '../services/policies.service';
import { Policy } from '../models';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[auth-policy]'
})

export class AuthPolicyDirective implements OnInit, OnDestroy {

  constructor(
    private element: ElementRef,
    private _userPoliciesService: PoliciesService,
  ) { }

  @HostBinding('class.disabled') isDisabled: boolean = false;

  private _subscriptionsArray: Array<Subscription> = [];
  private _userPolicyList: Array<Policy> = [];
  private _elementPolicyList: string[];
  private _restrictionAction: string;
  private _elementDisaplyAttribute: string;

  @Input()
  set authorizedPolicies(elementPolicyList: string[]) {
    if (Array.isArray(elementPolicyList)) {
      this._elementPolicyList = elementPolicyList;
    }
  }

  @Input()
  set restrictionAction(action: string) {
    this._restrictionAction = action;
    this.applyElementRestriction();
  }

  ngOnInit(): void {
    this._subscriptionsArray.push(this._userPoliciesService.getUserPolicies().subscribe(
      (policies: Policy[]) => {
        this._userPolicyList = policies;
        if (this.isElementRestrictedToUser()) {
          this.applyElementRestriction();
        } else {
          this.unApplyElementRestriction();
        }
      },
      () => { this.applyElementRestriction(); }
    ));
  }

  private isElementRestrictedToUser(): boolean {
    return !this._userPolicyList.some(userPolicy => this._elementPolicyList.includes(userPolicy.policyName));
  }

  private applyElementRestriction(): void {
    switch (this._restrictionAction) {
      case 'hidden': {
        this._elementDisaplyAttribute = this.element.nativeElement.style.display;
        this.element.nativeElement.style.display = 'none';
        break;
      }
      case 'disabled': {
        this.element.nativeElement.setAttribute('disabled', '');
        this.isDisabled = true;
        break;
      }
      default: {
        break;
      }
    }
  }

  private unApplyElementRestriction(): void {
    switch (this._restrictionAction) {
      case 'hidden': {
        this.element.nativeElement.style.display = this._elementDisaplyAttribute;
        break;
      }
      case 'disabled': {
        this.element.nativeElement.removeAttribute('disabled');
        this.isDisabled = false;
        break;
      }
      default: {
        break;
      }
    }
  }

  ngOnDestroy(): void {
    this._subscriptionsArray.forEach((sub)=>{
      sub.unsubscribe();
    });
  }

}
